import { lazy } from 'react'

export const DynamicLeftToRight = lazy(() => import('./DynamicLeftToRight'))
export const DynamicIntroSingleChoice = lazy(
  () => import('./DynamicIntroSingleChoice'),
)
export const DynamicIntroMultipleChoice = lazy(
  () => import('./DynamicIntroMultipleChoice'),
)
